import Delegate from 'ftdomdelegate'
let documentDelegate = new Delegate(document.body),
    headerBar = document.querySelector('#shopify-section-header')

documentDelegate.on('click', '[href^="#"], [data-href]', function (event, target) {
    let selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href')

    selector = /#(?:.(?!\\))+$/.exec(selector)[0]

    if (selector === '#') {
        return
    }

    let element = document.querySelector(selector),
        offset = parseInt(target.getAttribute('data-offset') || 0)

    if (headerBar) {
        offset -= headerBar.clientHeight
    }

    window.scrollTo({
        behavior: 'smooth',
        top: element.offsetTop - offset
    })

    event.preventDefault()
})